export enum APIScope {
  // The value is used in the URL
  // Naming patern should be object_verb

  SWIVL_ADMIN_ONLY = "swivl-admin-only",

  SWIVL_STAFF_ONLY = "swivl-staff-only",

  LOCAL_ONLY = "local-only",

  LOGGED_IN = "logged-in",
  ROLES_GET = "roles-get", // This needs to always be allowed.
  ROLES_SET = "roles-set",
  ROLES_VIEW = "roles-view",

  USER_CRM_VIEW = "user-crm-view",
  USER_CRM_WRITE = "user-crm-write",

  APPS_EDIT = "apps-edit",
  APPS_VIEW = "apps-view",

  MEMBERS_GET = "members-get",
  MEMBERS_SET = "members-set",

  LOCATIONS_ALL_VIEW = "locations-all-view",
  LOCATION_VIEW = "location-view", // For a specific location

  LOCATION_CREATE = "location-create",

  LOCATION_DETAILS_READ = "location-details-read",
  LOCATION_DETAILS_WRITE = "location-details-write",

  WORKFLOWS_VIEW = "workflows-view",
  WORKFLOWS_EDIT = "workflows-edit",

  FMS_EDIT = "fms-edit",
  FMS_VIEW = "fms-view",

  CONVERSATION_VIEW = "conversation-view",
  CONVERSATION_TAKEOVER = "conversation-takeover",

  SEQUENCES_EDIT = "sequences-edit",
  SEQUENCES_VIEW = "sequences-view",

  ESCALATIONS_EDIT = "escalations-edit",
  ESCALATIONS_HANDLE = "escalations-handle",

  REVIEWS_EDIT = "reviews-view",

  TICKETS_VIEW = "tickets-view",
  TICKETS_EDIT = "tickets-edit",

  // Widgets & Brands — Snowy operator-facing configuration of the customer-facing
  // surfaces: widgets, CTAs, install, and Brands. ADMIN = write, EDITOR = write CTAs,
  // read-only elsewhere. Renamed from WIDGET_BUILDER_* on 2026-09-08 (ENG-2894); see
  // docs/snowy/widget/2026-05-20-widget-builder-b0-plan.md and
  // docs/snowy/plans/2026-09-08-eng-2894-brands-page-rebuild.md.
  WIDGETS_AND_BRANDS_ADMIN = "widgets-and-brands-admin",
  WIDGETS_AND_BRANDS_EDITOR = "widgets-and-brands-editor"
}
export const LimitToLocationScopes = [APIScope.LOCATION_VIEW, APIScope.ESCALATIONS_HANDLE]; // This means that if any item is true in scope then this is a true permission.

// Scopes that are not exposed as toggles in the Roles UI. New custom roles must NOT seed these
// with an explicit FORBIDDEN — that would short-circuit `checkPermissionInRole` and break parent
// inheritance (e.g. LOCATION_VIEW would silently FORBIDDEN-out Property Manager for any custom
// role inheriting from agent/manager/admin). Keep this in sync with `Role.Settings.Details.View`.
export const NonRoleEditableAPIScopes: APIScope[] = [
  APIScope.SWIVL_ADMIN_ONLY,
  APIScope.SWIVL_STAFF_ONLY,
  APIScope.LOCAL_ONLY,
  APIScope.LOGGED_IN,
  APIScope.ROLES_GET,
  APIScope.LOCATION_VIEW
];

export enum APIScopeGroup {
  // A list of all posible API actons
  // LOGGED_IN = "logged-in",
  ROLES = "roles"
}

export enum APIScopePermission {
  ALLOWED = "allowed",
  FORBIDDEN = "forbidden",
  INHERITED = "inherited"
}

export type APIScopePermissionMap = { [action in APIScope]?: APIScopePermission };

export const AllAPIScopePermissions: { [action in APIScope]: APIScopePermission } = {
  [APIScope.SWIVL_ADMIN_ONLY]: APIScopePermission.ALLOWED,
  [APIScope.SWIVL_STAFF_ONLY]: APIScopePermission.ALLOWED,
  [APIScope.LOCAL_ONLY]: APIScopePermission.ALLOWED,
  [APIScope.LOGGED_IN]: APIScopePermission.ALLOWED,

  [APIScope.ROLES_GET]: APIScopePermission.ALLOWED,
  [APIScope.ROLES_SET]: APIScopePermission.ALLOWED,
  [APIScope.ROLES_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.USER_CRM_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.USER_CRM_WRITE]: APIScopePermission.ALLOWED,
  [APIScope.APPS_EDIT]: APIScopePermission.ALLOWED,
  [APIScope.APPS_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.MEMBERS_GET]: APIScopePermission.ALLOWED,
  [APIScope.MEMBERS_SET]: APIScopePermission.ALLOWED,
  [APIScope.LOCATIONS_ALL_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.LOCATION_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.LOCATION_CREATE]: APIScopePermission.ALLOWED,
  [APIScope.LOCATION_DETAILS_READ]: APIScopePermission.ALLOWED,
  [APIScope.LOCATION_DETAILS_WRITE]: APIScopePermission.ALLOWED,
  [APIScope.WORKFLOWS_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.WORKFLOWS_EDIT]: APIScopePermission.ALLOWED,
  [APIScope.FMS_EDIT]: APIScopePermission.ALLOWED,
  [APIScope.FMS_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.CONVERSATION_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.CONVERSATION_TAKEOVER]: APIScopePermission.ALLOWED,
  [APIScope.ESCALATIONS_EDIT]: APIScopePermission.ALLOWED,
  [APIScope.ESCALATIONS_HANDLE]: APIScopePermission.ALLOWED,
  [APIScope.REVIEWS_EDIT]: APIScopePermission.ALLOWED,

  [APIScope.SEQUENCES_EDIT]: APIScopePermission.ALLOWED,
  [APIScope.SEQUENCES_VIEW]: APIScopePermission.ALLOWED,

  [APIScope.TICKETS_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.TICKETS_EDIT]: APIScopePermission.ALLOWED,

  [APIScope.WIDGETS_AND_BRANDS_ADMIN]: APIScopePermission.ALLOWED,
  [APIScope.WIDGETS_AND_BRANDS_EDITOR]: APIScopePermission.ALLOWED
};
